module.exports = __webpack_public_path__ + "img/fa-tags.27fc802c.svg";